export const USER_TYPES = {
  parent: "parent",
  kid: "kid",
};

export const MOD_AVATAR_URL =
  "https://firebasestorage.googleapis.com/v0/b/tract-media/o/media%2Favatars%2Favatar_mod.png?alt=media";
